<template>
  <div id="product_detail">
    <call />
    <pop-alert />
    <!-- header -->
    <header>
      <header-app :rate="counterBlock" :canMobileOrder="isMobileOrderEnabled()"></header-app>
      <span><menu-app></menu-app></span>
      <div class="ssm-overlay ssm-toggle-nav"></div>
    </header>
    <!-- main -->
    <main>
      <!-- menu detail -->
      <section v-if="dataReady">
        <div class="l-main l-main--bg-border l-main--no-pd-bot l-main--bg-border--green pt-60">
          <div class="l-main__head">
            <div v-on:click="backPagePrevious" class="l-main__head--control l-main__head--control--back">
              <img src="/assets/images/icon/icon-back-white.svg?v=2" alt="">
            </div>
            <div class="l-main__head--title">詳細</div>
            <a href="javascript:void(0)" class="l-main__head--control">
            </a>
          </div>
          <div class="l-menu-detail">
            <!-- banner -->
            <div class="c-banner c-banner--menu mb-0">
              <!-- Swiper -->
              <div class="swiper-container c-banner__swiper js-banner-swiper" ref="jsBannerSwiper">
                <div class="swiper-wrapper">
                  <div v-for="(img, index) in product.image" :key="index" class="product-image swiper-slide js-keep-ratio" data-ratio="0.8220858896">
                    <img v-bind:src="getImgSrc(img)" alt="" :data-hash="`image_${index}`">
                  </div>
                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination"></div>
              </div>
            </div>
            <div class="handling-labels">
              <span class="handling-format-label togo" v-if="type == 'pickup' && product.acceptableHandlingFormatForPickup.includes(1) && handlingFormats.includes(1)">お持ち帰り</span>
              <span class="handling-format-label forhere" v-if="type == 'pickup' && product.acceptableHandlingFormatForPickup.includes(2) && handlingFormats.includes(2)">店内でお食事</span>
              <span class="handling-format-label drivethru" v-if="type == 'drivethru' && product.acceptableHandlingFormatForDelivery.includes(3) && handlingFormats.includes(3)">ドライブスルー</span>
              <span class="handling-format-label parkandpickup" v-if="type == 'parkandpickup' && product.acceptableHandlingFormatForDelivery.includes(4) && handlingFormats.includes(4)">駐車場受け取り</span>
            </div>
            <div class="l-menu-detail__info">
              <h1>{{ product.productName }}</h1>
              <p v-html="autolink(product.description)"></p>
              <div class="mb-8" v-if="type == 'pickup' && isPriceNoticeRequired(tenant)">
                <p>※軽減税率制度により「お持ち帰り」または「店内でお食事」にて税込価格表示が異なります </p>
              </div>
              <hr>
              <div class="d-flex justify-content-space align-items-center mb-41">
                <div class="c-list-menu__control--left" v-if="product && getProductPriceTaxed(product, type, tenant) > 0">
                  <div v-if="!product.sale" class="c-price-product">
                    {{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                  <div v-else class="c-price-product sale">
                    <span class="sale-original">{{ priceFormat(getProductPriceTaxed(product, type, tenant)) }}<small>円（税込）</small></span><br />
                    <small>SALE：</small>{{ priceFormat(getProductSalePriceTaxed(product, type, tenant)) }}<small>円（税込）</small>
                  </div>
                </div>
                <div class="c-list-menu__control--right">
                  <div @click.prevent="showOption(product.id)" :class="{'c-btn-add-cart': true, 'c-btn-reservation': type == 'reservation' }" v-if="!product.soldout">
                    {{type == 'reservation' ? 'リストへ追加' : 'カートに追加'}}
                  </div>
                  <div v-else class="c-btn-add-cart soldout" @click="showSoldout">
                    SOLDOUT
                  </div>
                </div>
              </div>
              <div v-on:click="backPagePrevious" class="c-btn-back-list box-center mb-51">
                一覧へ戻る
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer-cart></footer-cart>
      <alert :message="alert_msg" 
      :show="alert_show" 
      :closeModal="closeModal" 
      :confirm_show="confirm_show" 
      :confirm_message="confirm_msg" 
      :confirm_callback="confirm_callback" 
      :confirm_hide_cancel="confirm_hide_cancel"
      :label_cancel="confirm_label_cancel"
      :label_ok="confirm_label_ok"
      ></alert>
      <confirm-reservation 
        :callback="confirmCallback"
        :callbackComp="completeCallback" 
        :show="confirmReservationShow" 
        :closeModal="closeConfirmReservationPopup"
       />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Header from "../components/Header.vue";
import Menu from "../components/Menu.vue";
import Alert from "../components/Alert.vue";
import FooterCart from "../components/FooterCart.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import { getProvider, getProduct } from "../store/firestore";
import Swiper, { Navigation, Pagination } from "swiper";
const $ = window.$;
import PopAlert from "../components/PopAlert.vue";
import ConfirmReservation from "../components/ConfirmReservation.vue";

Swiper.use([Navigation, Pagination]);

export default Vue.extend({
  name: "MobileOrderProduct",
  components: {
    'header-app': Header,
    'menu-app': Menu,
    'footer-cart': FooterCart,
    'alert': Alert,
    PopAlert,
    ConfirmReservation
  },
  mixins: [Tenant],
  async created() {
    this.tenantId = this.$route.params.id;
    this.type = this.$route.params.type;
    this.productId = this.$route.params.productId;
    const tenant = await getProvider(this.tenantId);
    const now = Date.now();
    const product = await getProduct(this.tenantId, this.productId, this.$store.state.userId);
    if(!product){
      alert("指定された商品がみつかりませんでした。");
      this.$router.push('/mobileorder');
      return;
    }
    let handlingFormats = this.getHandlingFormats(tenant, this.type);
    this.handlingFormats = handlingFormats;
    switch(this.type){
      case 'pickup': {
          if ( tenant.handlingFormatToGo && tenant.handlingFormatToGo.enabled) {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 1);
            // name = "お持ち帰り";
          } else if ( tenant.handlingFormatForHere && tenant.handlingFormatForHere.enabled) {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 2);
            //name = "店内でお食事";
          }
          if(tenant.pickupDiscloseAt > now){
            this.alert("現在モバイルオーダーを提供していません。モバイルオーダートップに戻ります。");
            this.$router.push('/mobileorder');
            return;
          }
          this.setting = tenant.pickUp;
          this.orderType = "モバイルオーダー";
          break;
        }
      case 'delivery':
      case 'drivethru':
      case 'parkandpickup': {
          if (this.type == 'drivethru') {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 3);
          } else {
            this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 4);
          }
          const orderType = this.type == 'drivethru' ? 'ドライブスルー' : '駐車場受け取り';
          if(tenant.deliveryDiscloseAt > now){
            this.alert(`現在${orderType}を提供していません。モバイルオーダートップに戻ります。`);
            this.$router.push('/mobileorder');
            return;
          }
          this.setting = tenant.delivery;
          this.orderType = orderType;
          break;
        }
      case 'reservation':
        this.baseHandlingFormatSetting = this.getHandlingFormatSetting(tenant, 5);
        if(tenant.reservationDiscloseAt > now){
          await this.confirm(`現在${this.orderType}を提供していません。店舗トップに戻ります。`, true);
          this.$router.push('/shop/list?id='+this.tenantId);
          return;
        }
        this.setting = tenant.reservation;
        break;
      default:
        this.alert("不正なURLです。モバイルオーダートップに戻ります。");
        this.$router.push('/mobileorder');
        break;
    }
    this.tenant = tenant;
    product.description = Common.addExtLink(product.description);
    this.product = product;
    this.dataReady = true;
  },
  data() {
    return {
      tenant: undefined,
      type: undefined,
      products: undefined,
      dataReady: false,
      orderType: undefined,
      handlingFormats: [],
      baseHandlingFormatSetting: null,
      confirmReservationShow: null
    }
  },
  mounted() {
    Common.initDom();
  },
  updated() {
    // swiper banner
    var banner_swiper = new Swiper('.js-banner-swiper', {
      slidesPerView: 1,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      }
    });
    banner_swiper.on('slideChange', function(){
      $(".swiper-pagination-bullet").removeClass("swiper-pagination-bullet-active");
      $(".swiper-pagination-bullet:eq("+banner_swiper.activeIndex+")").addClass("swiper-pagination-bullet-active");
    }); 

    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    isPriceNoticeRequired(tenant){
      //「商品提供方法がお持ち帰りの場合、容器代等が加わり商品単価が変わります」
      return tenant && tenant.shopCategoryType == 5 
        && tenant?.handlingFormatToGo?.enabled 
        && tenant?.handlingFormatForHere?.enabled;
    },
    isReservation() {
      //来店予約でかつ商品が存在する場合
      const cartData = {...this.$store.state.cart};
      for (const [key, tenantCart] of Object.entries(cartData)) {
        if (tenantCart && tenantCart.orderType == 3) {
          this.confirmReservationShow = true;
          return false;
        }
      }
      return true;
    },
    getOrderType(){
      switch(this.type){
        case 'pickup':
          return 1;
        case 'delivery':
        case 'drivethru':
        case 'parkandpickup':
          return 2;
        case 'reservation':
          return 3;
        default:
          //nothing
      }
    },
    // カートクリア
    async confirmCallback() {
      let orderType = this.getOrderType();
      if (this.tenantId && orderType == 3) {
        //来店予約の時にカート情報消して詳細画面戻る
        await this.$store.dispatch('clearCart');
        this.$router.push(`/mobileorder/shop/${this.tenantId}/reservation`);
      } else {
        this.backPagePrevious();
      }    
    },
    closeConfirmReservationPopup() {
      this.confirmReservationShow = false;
    },
    completeCallback() {
      this.$router.push('/mobileorder/checkout');
    },
    async showOption(productId) {
      if (!this.isReservation()) return false;
      if (this.isOrderEnabled(this.tenant, this.type)) {
        this.$router.push(`/mobileorder/shop/${this.tenantId}/${this.type}/${productId}/option`);
      } else {
        await this.confirm("ただいまの時間は受け付けておりません。", true);
      }
    },
    async showSoldout() {
      await this.confirm("この商品は現在売り切れのためご注文いただけません。", true);
    }
  }
});
</script>